import React from "react";
import { Dropdown, Menu, Tag } from "antd";

const AssignDropDown = ({
  handleAppRole,
  handleOffice,
  handleRetractOffice,
}) => {
  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: <a onClick={() => handleAppRole()}>Assign App role</a>,
        },
        {
          key: "2",
          label: <a onClick={() => handleOffice()}>Assign office</a>,
        },
        {
          key: "3",
          label: <a onClick={() => handleRetractOffice()}>Retract office</a>,
        },
      ]}
    />
  );
  return (
    <>
      <Dropdown
        overlay={menu}
        placement="bottom"
        arrow
        className="cursor-pointer"
      >
        <Tag color="blue">Action </Tag>
      </Dropdown>
    </>
  );
};

export default AssignDropDown;
